import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { Auftragdetails } from '../../auftragdetails.helper';
import { Subscription } from 'rxjs';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { Regel } from 'src/app/api/model/swagger-model';
import { AuftragHelper } from 'src/app/api/helper/auftrag-helper';

const log = new Logger("AuftragRegelInfoComponent");

@Component({
    selector: 'auftrag-regel-info',
    templateUrl: './auftrag-regel-info.component.html',
    styleUrls: ['./auftrag-regel-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragRegelInfoComponent implements OnInit, OnChanges, OnDestroy {

    @Input() auftragdetails: Auftragdetails;

    subscriptions: Subscription[] = [];

    aktiv = false;

    aktiveRegeln: Regel[] = [];

    constructor(
        private router: Router,
        private modalController: ModalController,
        private stammdatenService: StammdatenService,
        protected cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(() => {
            this.update();
        }));

        this.subscriptions.push(this.stammdatenService.regeln.subscribe(() => {
            this.update();
        }));

        this.update();
    }

    update() {
        this.aktiveRegeln = AuftragHelper.getZutreffendeRegeln(this.auftragdetails.auftrag);

        this.aktiv = this.aktiveRegeln?.length > 0;
        this.cdr.detectChanges();
    }

    init() {
    }

    ngOnDestroy(): void {
        // log?.debug('ngOnDestroy');
        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    onWorkflowChanged() {
    }

}
